class MCartRemoveButton extends HTMLElement {
	constructor() {
		super()

		this.addEventListener('click', (event) => {
			event.preventDefault()
			const cartItems = this.closest('m-cart') || this.closest('m-cart-drawer-items')
			cartItems.updateQuantity(this.dataset.index, 0)
		})
	}
}

customElements.define('m-cart-remove-button', MCartRemoveButton)

class MCartTemplate extends HTMLElement {
	constructor() {
		super()
		this.cartUpdateUnsubscriber = undefined
		this.isCartPage = MinimogSettings.templateName === 'cart'
		this.cartDrawerWrapper = document.querySelector('m-cart-drawer')
		this.cartDrawerInner = document.querySelector('.m-cart-drawer__inner')
		this.mainCartItems = this.querySelector('[data-minimog-cart-items]')
		this.cartSubTotal = this.querySelector('[data-cart-subtotal]')
		this.cartDiscount = this.querySelector('[data-minimog-cart-discounts]')
		this.giftWrapping = this.querySelector('[data-minimog-gift-wrapping]')
		let loadingTarget = this.cartDrawerInner

		if (this.isCartPage) loadingTarget = document.body
		this.loading = new MinimogLibs.AnimateLoading(loadingTarget, { overlay: loadingTarget })

		this.rootUrl = window.Shopify.routes.root

		const debouncedOnChange = debounce((event) => {
			if (event.target.name !== 'id') {
				this.onChange(event)
			}
		}, 300)
		if (this.isCartPage) {
			this.mainCartItems.addEventListener('change', debouncedOnChange.bind(this))
		} else {
			this.addEventListener('change', debouncedOnChange.bind(this))
		}

		MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (response) => {
			this.getCart().then((cart) => {
				this.updateCartCount(cart.item_count)
			})
		})
	}

	updateCartCount(itemCount) {
		const cartCounts = document.querySelectorAll('.m-cart-count-bubble')
		cartCounts.forEach((cartCount) => {
			if (itemCount > 0) {
				cartCount.textContent = itemCount
				cartCount.classList.remove('m:hidden')
			} else {
				cartCount.classList.add('m:hidden')
			}
		})
	}

	getCart() {
		return fetchJSON(this.rootUrl + 'cart.json')
	}

	connectedCallback() {
		this.cartUpdateUnsubscriber = MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (event) => {
			if (event.source === 'main-cart-items') {
				return
			}
			this.onCartUpdate()
		})
	}

	disconnectedCallback() {
		if (this.cartUpdateUnsubscriber) {
			this.cartUpdateUnsubscriber()
		}
	}

	onCartUpdate(renderFooter = true) {
		const { routes } = window.MinimogSettings
		fetch(`${routes.cart}?section_id=${this.dataset.sectionId}`)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html')

				this.getSectionsToRender().forEach((section) => {
					const elementToReplace =
						document.getElementById(section.id).querySelector(section.selector) ||
						document.querySelector(section.selector) ||
						document.getElementById(section.id)
					const newElement = html.querySelector(section.selector) || html.getElementById(section.id)

					if (elementToReplace && newElement) {
						elementToReplace.innerHTML = newElement.innerHTML
					}
				})
			})
			.catch((e) => {
				console.error(e)
			})
	}

	onChange(event) {
		this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'))
	}

	updateQuantity(line, quantity, name) {
		this.loading.start()

		const { routes } = window.MinimogSettings

		const body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		})

		fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => {
				return response.text()
			})
			.then((state) => {
				const parsedState = JSON.parse(state)
				let quantityElement = document.getElementById(`MinimogDrawer-quantity-${line}`)
				if (this.isCartPage) {
					if (MinimogTheme.config.mqlMobile) {
						quantityElement = document.querySelector(`.MinimogQuantity-${line}.MinimogQuantity-mobile`)
					} else {
						quantityElement = document.querySelector(`.MinimogQuantity-${line}.MinimogQuantity-desktop`)
					}
				}
				const items = document.querySelectorAll('.m-cart-item')

				if (parsedState.errors) {
					this.loading.finish()
					quantityElement.value = quantityElement.getAttribute('value')
					this.updateLiveRegions(line, parsedState.errors)
					return
				}

				this.classList.toggle('m-cart--empty', parsedState.item_count === 0)
				if (this.cartDrawerWrapper)
					this.cartDrawerWrapper.classList.toggle('m-cart--empty', parsedState.item_count === 0)

				this.getSectionsToRender().forEach((section) => {
					const elementToReplace =
						document.getElementById(section.id).querySelector(section.selector) ||
						document.querySelector(section.selector) ||
						document.getElementById(section.id)

					elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)
				})

				const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined
				let message = ''
				if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
					if (typeof updatedValue === 'undefined') {
						message = window.MinimogStrings.cartError
					} else {
						message = window.MinimogStrings.quantityError.replace('{{ quantity }}', updatedValue)
					}
				}
				this.updateLiveRegions(line, message)

				MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { ...parsedState, source: 'main-cart-items' })
				document.dispatchEvent(
					new CustomEvent('cart:updated', {
						detail: {
							cart: parsedState,
						},
					})
				)
			})
			.catch(() => {})
			.finally(() => {
				this.loading.finish()
			})
	}

	updateLiveRegions(line, message) {
		let lineItemNode = document.getElementById(`MinimogCartDrawer-Item-${line}`)
		if (this.isCartPage) lineItemNode = document.getElementById(`MinimogCart-Item-${line}`)
		if (message !== '' && lineItemNode) {
			MinimogTheme.Notification.show({
				target: lineItemNode,
				type: 'warning',
				message: message,
			})
		}
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
	}

	getSectionsToRender() {
		return [
			{
				id: 'MinimogCart',
				section: this.dataset.sectionId,
				selector: '#MinimogCartHeader',
			},
			{
				id: 'MinimogCart',
				section: this.dataset.sectionId,
				selector: '[data-minimog-cart-items]',
			},
			{
				id: 'MinimogCart',
				section: this.dataset.sectionId,
				selector: '#MinimogCartFooter',
			},
		]
	}
}

customElements.define('m-cart', MCartTemplate)

if (!customElements.get('l-shipping-threshold')) {
	customElements.define(
		'l-shipping-threshold',
		class LTAShippingThreshold extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				// Elements

				// Events
				this.cartUpdateUnsubscriber = MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (event) => {
					const sections = event.sections
					const cartTemplate = sections['cart-template'] || sections['cart-drawer']
					const newShippingThresHoldEl = new DOMParser()
						.parseFromString(cartTemplate, 'text/html')
						.querySelector('l-shipping-threshold')

					// if (!newShippingThresHoldEl) return

					this.innerHTML = newShippingThresHoldEl.innerHTML
				})
			}
		}
	)
}

if (!customElements.get('l-cart-count')) {
	customElements.define(
		'l-cart-count',
		class LTACartCount extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				this.cartUpdateUnsubscriber = MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (event) => {
					const sections = event.sections
					const cartTemplate = sections['cart-template']

					const cartCountEl = new DOMParser()
						.parseFromString(cartTemplate, 'text/html')
						.querySelector('l-cart-count').innerHTML

					this.innerHTML = cartCountEl
				})
			}
		}
	)
}

if (!customElements.get('l-cart-note')) {
	customElements.define(
		'l-cart-note',
		class LTACartNote extends HTMLElement {
			constructor() {
				super()

				this.textAreaEl = this.querySelector('textarea')

				this.addEventListener(
					'input',
					debounce((event) => {
						const body = JSON.stringify({ note: this.textAreaEl.value })
						fetch(`${window.MinimogSettings.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
					}, 300)
				)
			}
		}
	)
}

/*******************************************
 * [COMPONENT]: SHIPPING BAR
 ********************************************/

if (!customElements.get('l-cart-thresholds')) {
	class LTACartThresholds extends HTMLElement {
		constructor() {
			super()
			this.progressBarEl = null
			this.thresholdsEl = null
			this.labelEl = null
			this.data = null
		}

		connectedCallback() {
			this.progressBarEl = this.querySelector('[data-progress-bar]')
			this.thresholdsEl = this.querySelector('[data-thresholds]')
			this.labelEl = this.querySelector('[data-label]')
			this._initialize()
		}

		_initialize() {
			this._parseData()
			this._updateCart()
		}

		_parseData() {
			const scriptTag = this.querySelector('script[type="application/json"]')
			const parsedData = this.data || (scriptTag ? JSON.parse(scriptTag.textContent) : {})
			const { cartTotal = 0, cartCurrency, shopCurrency, thresholds = [] } = parsedData

			const isCurrencyDifferent = cartCurrency !== shopCurrency

			const normalizeThreshold = (threshold) => ({
				...threshold,
				threshold: parseFloat(threshold.threshold),
			})

			const convertThreshold = (threshold) => ({
				...threshold,
				threshold: Currency.convert(parseFloat(threshold.threshold), shopCurrency, cartCurrency),
			})

			let convertedCartTotal = parseFloat(cartTotal)
			let convertedThresholds = thresholds.map(normalizeThreshold)

			if (isCurrencyDifferent) {
				convertedCartTotal = Currency.convert(cartTotal, shopCurrency, cartCurrency)
				convertedThresholds = thresholds.filter((t) => t.enabled).map(convertThreshold)
			}

			const maxThreshold = convertedThresholds.length ? Math.max(...convertedThresholds.map((t) => t.threshold)) : 1 // Prevent division by zero

			const activeThresholds = convertedThresholds.filter((t) => t.enabled && convertedCartTotal >= t.threshold)

			const currentProgress = convertedCartTotal / maxThreshold
			const currentProgressPercentage = Math.min(currentProgress * 100, 100)

			this.data = {
				...parsedData,
				cartTotal: convertedCartTotal,
				thresholds: convertedThresholds,
				maxThreshold,
				activeThresholdsCount: activeThresholds.length,
				currentProgressPercentage,
			}
		}

		_render() {
			this._updateProgressBar()
			this._renderThresholds()
			this._renderLabel()
		}

		_updateProgressBar() {
			const { thresholds, activeThresholdsCount, cartTotal } = this.data
			const enabledThresholds = thresholds.filter((t) => t.enabled)
			const total = enabledThresholds.length || 1
			let percentage = 0

			if (enabledThresholds.length == 1) {
				const onlyThreshold = enabledThresholds[0]
				percentage = (cartTotal / onlyThreshold.threshold) * 100
			} else {
				percentage = activeThresholdsCount === 0 ? 25 : (activeThresholdsCount / total) * 100
			}

			if (this.progressBarEl) {
				this.progressBarEl.style.setProperty('--l-progress-bar-width', `${percentage}%`)
			}
		}

		_renderThresholds() {
			const { thresholds, cartTotal } = this.data
			let thresholdHTML = '<div><div></div></div>'
			const activeThresholds = thresholds.filter((t) => t.enabled).length
			const sortedThresholds = [...thresholds].sort((a, b) => a.threshold - b.threshold)

			sortedThresholds.forEach(({ enabled, label, threshold }) => {
				const isActive = cartTotal >= threshold

				if (enabled) {
					thresholdHTML += `
					<div class="l-cdShippingBar__threshold l-flex-center l-flex-col l-text-center">
						<span class="l-cdShippingBar__threshold-circle l-sq l-inline-flex l-block-spacing${isActive ? ' is-active' : ''}"></span>
						<span class="l-cdShippingBar__threshold-label l-block-text l-block-spacing${isActive ? ' is-active' : ''}">${label}</span>
						<span class="l-cdShippingBar__threshold-money l-block-text">${formatMoney(threshold)}</span>
					</div>`
				}
			})

			if (this.thresholdsEl) {
				this.thresholdsEl.innerHTML = thresholdHTML
				this.thresholdsEl.classList.add(`l-${activeThresholds}-count`)
			}
		}

		_renderLabel() {
			const { successMessage, progressMessage, cartTotal, thresholds, activeThresholdsCount, maxThreshold } = this.data

			const enabledThresholds = thresholds.filter((t) => t.enabled)
			let notificationText = successMessage

			if (enabledThresholds.length >= 1) {
				const sorted = [...enabledThresholds].sort((a, b) => a.threshold - b.threshold)
				const minThreshold = sorted[0]
				const maxThresholdObj = sorted[1]

				console.log({ minThreshold, maxThresholdObj })

				if (activeThresholdsCount === 0) {
					notificationText = progressMessage
						.replace('[money]', formatMoney(minThreshold.threshold - cartTotal))
						.replace('[name]', minThreshold.label)
				} else if (activeThresholdsCount < thresholds.length && thresholds.length >= 1) {
					notificationText = progressMessage
						.replace('[money]', formatMoney(maxThreshold - cartTotal))
						.replace('[name]', maxThresholdObj.label)
				}
			}

			if (this.labelEl && notificationText) {
				this.labelEl.innerHTML = notificationText
			}
		}

		_updateCart() {
			const { cartTotal, thresholds } = this.data

			const freeGiftCard = thresholds.find((t) => t.variantId && t.enabled)

			let needToUpdateCart = false
			let cartUpdateObj = null

			// Need to add freeGiftCard
			if (freeGiftCard?.itemsInCart == 0 && freeGiftCard?.threshold <= cartTotal) {
				cartUpdateObj = { [freeGiftCard.variantId]: 1 }
			}

			// Need to remove
			if (freeGiftCard?.itemsInCart > 0 && freeGiftCard?.threshold > cartTotal) {
				cartUpdateObj = { [freeGiftCard.variantId]: 0 }
			}

			if (!cartUpdateObj) {
				this._render()

				return
			}

			console.log(cartUpdateObj)

			// Add selected variant to cart
			L_ATC.updateCart({
				...cartUpdateObj,
			})
				.then((response) => {
					console.log(response)
				})
				.catch((error) => {
					console.error(error)
				})
				.finally(() => {
					this._render()
				})
		}
	}

	customElements.define('l-cart-thresholds', LTACartThresholds)
}

